module.exports = __webpack_public_path__ + "img/ic-file-doc.dbdc55f7.svg";